import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { amtFmt } from '../utils'
import noUiSlider from 'nouislider'
import { withRouter } from 'react-router'
import * as actions from '../actions'
import * as types from '../constants'
import queryString from 'query-string'
class Area extends React.Component {
  constructor(props) {
    super(props)
    this.areaSlider = React.createRef()
    this.AreaSliderLowerValue = React.createRef()
    this.AreaSliderUpperValue = React.createRef()
    this.state = {
      minArea: 0,
      maxArea: 0,
      defaultMinArea: 0,
      defaultMaxArea: 0,
      areaRange: [],
      checkUpdateStatus: false,
    }
  }
  componentDidUpdate() {
    if (this.props.filterTypes.length >= 0 && this.state.checkUpdateStatus === false) {
      const queryStr = queryString.parse(this.props.location.search)
      let min = queryStr.minArea,
        max = queryStr.maxArea,
        defaultMin = this.props.filterTypes[1].value[0],
        defaultMax = this.props.filterTypes[1].value[1]
      this.setState(
        {
          minArea: typeof min === 'undefined' || min === 'NaN' ? types.MIN : Number(min),
          maxArea:
            typeof max === 'undefined' || max === 'NaN' ? (typeof min !== 'undefined' && min !== 'NaN' ? Number(min) + types.MAX : types.MAX) : Number(max),
          defaultMinArea: defaultMin === null ? types.MIN : defaultMin,
          defaultMaxArea:
            defaultMax === null ? (defaultMin !== null ? defaultMin + types.MAX : types.MAX) : defaultMin === defaultMax ? defaultMax + types.MAX : defaultMax,
          checkUpdateStatus: true,
        },
        () => {
          this.addAreaRangeSlider()
          this.handleAreaRangeSliderUpdate()
        }
      )
    }
  }

  getAreaRangeSliderEle = () => this.areaSlider.current

  addAreaRangeSlider() {
    const queryStr = queryString.parse(this.props.location.search)
    const queryStrMaxArea =
      typeof queryStr.maxArea === 'undefined' || queryStr.maxArea === 'NaN'
        ? typeof queryStr.minArea !== 'undefined' && queryStr.minArea !== 'NaN'
          ? Number(queryStr.minArea) + types.MAX
          : types.MAX
        : Number(queryStr.maxArea)
    noUiSlider.create(this.getAreaRangeSliderEle(), {
      start: [this.state.minArea, queryStrMaxArea !== 0 ? queryStrMaxArea : this.state.defaultMaxArea],
      // snap: true,
      connect: true,
      range: {
        min: this.state.defaultMinArea,
        max: this.state.defaultMaxArea,
      },
    })
    queryStrMaxArea > this.state.defaultMaxArea && this.resetAreaSlider(queryStrMaxArea)
  }

  handleAreaRangeSliderUpdate() {
    this.sliderUpdate('slide')
    this.sliderUpdate('update')
  }

  sliderUpdate(type) {
    let sliderValues = [this.AreaSliderLowerValue.current, this.AreaSliderUpperValue.current]

    this.getAreaRangeSliderEle().noUiSlider.on(type, (values, handle) => {
      let val = Math.round(values[handle])
      sliderValues[handle].innerHTML = `${amtFmt(val)} sqft`
      let area = handle ? 'maxArea' : 'minArea'
      this.setState(
        {
          [area]: val,
        },
        () => {
          type === 'slide' && this.props.sendAreaRange(this.state.minArea, this.state.maxArea)
        }
      )
    })
  }
  resetAreaSlider(queryStrMaxArea) {
    this.getAreaRangeSliderEle().noUiSlider.updateOptions({
      start: [this.state.minArea, queryStrMaxArea],
      connect: true,
      range: {
        min: this.state.defaultMinArea,
        max: queryStrMaxArea,
      },
    })
  }

  handleResetClick() {
    this.resetAreaSlider()
  }

  render() {
    return (
      <div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: '17px',
          }}>
          <span ref={this.AreaSliderLowerValue} />
          <span ref={this.AreaSliderUpperValue} />
        </div>
        <div ref={this.areaSlider} />
      </div>
    )
  }
}

function mapStateToProps(state) {
  let minAreaVal, maxAreaVal
  if (state.filters.filterTypes.length > 0) {
    minAreaVal = state.filters.filterTypes[1].value[0]
    maxAreaVal = state.filters.filterTypes[1].value[1]
  }
  return {
    minArea: minAreaVal,
    maxArea: maxAreaVal,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  }
}
const area = connect(
  mapStateToProps,
  mapDispatchToProps
)(Area)

export default withRouter(area)



// WEBPACK FOOTER //
// ./src/components/AreaRangeSlider.js